module.exports = new __parcel__URL__("arrow-right-disabled.4aa73a65.svg").toString();